import React from 'react';
import { Handle, Position } from 'reactflow';
import { User } from 'lucide-react';

const InputNode = ({ data, isConnectable }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-md bg-white border-2 border-indigo-200 node-input">
      <div className="flex items-center">
        <User className="w-4 h-4 text-indigo-600 mr-2" />
        <div className="ml-2">
          <div className="text-lg font-bold text-indigo-800">Student Input</div>
          <div className="text-sm text-gray-600">
            Collect student responses
          </div>
          <div className="text-xs text-indigo-600">
            Type: {data.config?.inputType || 'text'}
          </div>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        id="output"
        isConnectable={isConnectable}
        className="w-3 h-3 bg-indigo-500 border-2 border-white"
      />
    </div>
  );
};

export default InputNode;